// @ts-nocheck

import { createSelector } from 'reselect';

const selectGRRulesButtonProps = createSelector([], () => {});

export default selectGRRulesButtonProps;
